import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/list/listseparatorview
 */
import View from "../view";
/**
 * The list separator view class.
 *
 * @extends module:ui/view~View
 */

var ListSeparatorView =
/*#__PURE__*/
function (_View) {
  _inherits(ListSeparatorView, _View);

  /**
   * @inheritDoc
   */
  function ListSeparatorView(locale) {
    var _this;

    _classCallCheck(this, ListSeparatorView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListSeparatorView).call(this, locale));

    _this.setTemplate({
      tag: 'li',
      attributes: {
        class: ['ck', 'ck-list__separator']
      }
    });

    return _this;
  }

  return ListSeparatorView;
}(View);

export { ListSeparatorView as default };